<template>
  <div class="invite-team-edit-claim" >
    <div class="main">
      <div class="title" >
        <h3>认领球队</h3>
        <p>要认领的球队</p>
      </div>
      <van-checkbox-group>
        <van-cell-group class="checkbox">
          <van-cell>
            <div class="player" >
              <div>
                <img :src="formatterImgSrc(teamInfo.badge)">
              </div>
              <div>
                <p>{{teamInfo.name}}</p>
                <span>{{playerCount}}人</span>
              </div>
            </div>
          </van-cell>
        </van-cell-group>
      </van-checkbox-group>
      <div class="foot" >
        <van-button type="primary" size="large" @click="applyJoinBMMatchTeam" >确认</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { getBMTeamDetailV2, applyJoinBMMatchTeam, getBMTeamPlayerList } from '@/api/team'
import { ImageFormat } from '@/utils/'

export default {
  name: 'Replace',
  data() {
    return {
      query: this.$route.query,
      teamInfo: {},
      playerCount: null
    }
  },
  created() {
    this.matchId = this.query.matchId
    this.teamId = this.query.teamId
    this.getBMTeamDetailV2()
    this.getBMTeamPlayerList()
  },
  computed: {
    formatterImgSrc() {
      return function(src) {
        return ImageFormat.imageView(src, 104, 104)
      }
    }
  },
  methods: {
    getBMTeamDetailV2() {
      let params = {
        teamId: this.teamId,
        matchId: this.matchId
      }
      getBMTeamDetailV2(params).then((response) => {
        let data = response.data
        this.teamInfo = data.currentTeamInfo
      })
    },
    applyJoinBMMatchTeam() {
      let params = {
        teamId: this.query.teamId,
        relationTeam: 91,
        verifyCode: this.query.code
      }
      applyJoinBMMatchTeam(params).then((response) => {
        const data = response.data
        if (data) {
          this.$router.push({name: 'InviteTeamInfo', query: {matchId: this.matchId, teamId: this.teamId}})
        }
      })
    },
    getBMTeamPlayerList() {
      let params = {
        teamId: this.teamId,
        matchId: this.matchId
      }
      getBMTeamPlayerList(params).then(response => {
        this.playerCount = response.data.players.length
      })
    }
  }
}
</script>

<style lang="stylus">
.invite-team-edit-claim
  .title
    padding: 10px 15px
    h3
      font-size:30px;
      font-weight:400;
      color:rgba(0,0,0,1);
      margin: 0
    p
      font-size:18px;
      font-family:PingFangSC-Regular;
      font-weight:400;
      color:rgba(0,0,0,1);
      margin 0
      padding-top: 10px
  .player
    display flex
    width 100%
    padding 15px
    div:first-child
      width 52px
      height 52px
      margin-right: 10px
      img
        width 52px
        height 52px
    div:last-child
      display flex
      flex-direction column
      justify-content: space-between;
      width: calc(100% - 62px)
      p
        margin: 0;
        font-size:14px;
        font-weight:400;
        color:rgba(0,0,0,1);
      span
        font-size:12px;
        font-weight:400;
        color:rgba(129,129,129,1);
  .checkbox
    .van-cell
      padding: 0
      .van-cell__value
        display flex
        justify-content: space-between
        align-items: center
        .van-checkbox
          padding-right 15px
          align-items: center
  .foot
    position absolute
    bottom 0
    width 100%
    .van-button
      border none
      font-size:16px;
      font-weight normal
      color: #32A377;
      line-height:25px;
    .van-button--primary
      background-color #FAFAFA
      font-size:20px;
      font-weight:400;
</style>



// WEBPACK FOOTER //
// src/pages/invite-team/user/claim.vue